import { Box, Grid, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import styles from '../styles';

function MobileWellboreRunInput({ data, columns, updateData, loading, disableTable }) {
  const classes = styles();
  const anyRowDirty = data?.some((row) => row?.isDirty);

  const handleChange = (event, { id, field }) => {
    event.stopPropagation();
    event.preventDefault();
    const newValue = event.target.value;
    const isValidNumber = /^-?\d*\.?\d*$/.test(newValue);
    if (isValidNumber) {
      updateData(id, field, newValue);
    }
  };

  return (
        <>
            {data.map((row, index) => {
              const isRowLocked = disableTable || (anyRowDirty && !row?.isDirty);
              return (
                <Box key={row.id ?? index} className={classes.gridContainer} sx={{ opacity: isRowLocked ? 0.5 : 1, pointerEvents: isRowLocked && 'none' }}>
                    {columns.map((col) => {
                      const params = {
                        row,
                        field: col.field,
                        value: row[col.field],
                        id: row._id ?? row.id ?? index,
                      };

                      if (col?.hide) return null;

                      return (
                            <Grid container key={col.field} className={classes.gridItem}>
                                <Typography
                                    className={classes.headerName}
                                    variant="body1"
                                    sx={{ pt: '5px', alignSelf: 'center' }}
                                >
                                    {col.headerName}
                                </Typography>

                                <Box sx={{ flex: 0.5, display: 'flex', justifyContent: 'center' }}>
                                    {col.renderEditCell
                                      ? (
                                          col.renderEditCell({
                                            ...params,
                                            onChange: (event) =>
                                              handleChange(event, { id: params.id, field: col.field }),
                                          })
                                        )
                                      : col.renderCell
                                        ? (
                                            col.renderCell(params)
                                          )
                                        : (
                                                <TextField
                                                    disabled={loading || !col.editable || isRowLocked}
                                                    variant="filled"
                                                    sx={{
                                                      flex: 1,
                                                      p: 0,
                                                      m: 0,
                                                      '.MuiInputBase-input': {
                                                        padding: '10px',
                                                        textAlign: 'center',
                                                      },
                                                    }}
                                                    value={
                                                        col?.valueGetter
                                                          ? col.valueGetter(params)
                                                          : params.value ?? ''
                                                    }
                                                    InputProps={{
                                                      disableUnderline: true,
                                                    }}
                                                    onChange={(event) =>
                                                      handleChange(event, { id: params.id, field: col.field })
                                                    }
                                                />
                                          )}
                                </Box>
                            </Grid>
                      );
                    })}
                </Box>
              );
            })}
        </>
  );
}

MobileWellboreRunInput.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  updateData: PropTypes.func,
  loading: PropTypes.bool,
  disableTable: PropTypes.bool
};

export default MobileWellboreRunInput;
